import React, { useState, useEffect } from 'react';
import Popup from 'react-popup';
import intl from 'react-intl-universal';

/**
 * Shipping data form component.
 * @param {Object} props - Component properties.
 * @param {Object} props.order - Order object.
 * @param {Object} props.shippingData - Shipping data.
 * @param {Function} props.onSave - Function called on save.
 * @param {boolean} props.isEditing - Whether the form is in edit mode.
 */
const ShippingDataForm = (props) => {
	const shippingData = props.shippingData || {};
	const [delivery_name, setDeliveryName] = useState(shippingData.receiver_name || props.order.delivery_name || '');
	const [delivery_street, setDeliveryStreet] = useState(shippingData.receiver_street || props.order.delivery_street || '');
	const [delivery_zip, setDeliveryZip] = useState(shippingData.receiver_zip || props.order.delivery_zip || '');
	const [delivery_city, setDeliveryCity] = useState(shippingData.receiver_city || props.order.delivery_city || '');
	const [delivery_phone, setDeliveryPhone] = useState(shippingData.receiver_phone || props.order.delivery_phone || '');
	const [delivery_email, setDeliveryEmail] = useState(shippingData.receiver_email || props.order.delivery_email || '');

	useEffect(() => {
		const shippingData = props.shippingData || {};
		setDeliveryName(shippingData.receiver_name || props.order.delivery_name || '');
		setDeliveryStreet(shippingData.receiver_street || props.order.delivery_street || '');
		setDeliveryZip(shippingData.receiver_zip || props.order.delivery_zip || '');
		setDeliveryCity(shippingData.receiver_city || props.order.delivery_city || '');
		setDeliveryPhone(shippingData.receiver_phone || props.order.delivery_phone || '');
		setDeliveryEmail(shippingData.receiver_email || props.order.delivery_email || '');
	}, [props.shippingData, props.order]);


	const [isEditing, setIsEditing] = useState(props.isEditing || false);

	return (
		<div id="root">
			<main>
				<div className="shipping_header">
					{!isEditing ? (
						<>
							<button className="pull-left secondary" onClick={() => Popup.close()}>{intl.get('Wstecz')}</button>
							<button onClick={() => setIsEditing(true)} className="pull-right" id="edytuj">{intl.get('Edytuj')}</button>
						</>
					) : (
						<>
							<button className="pull-left secondary" onClick={() => setIsEditing(false)}>{intl.get('Anuluj')}</button>
							<button onClick={() => {
								const data = {
									delivery_name,
									delivery_street,
									delivery_zip,
									delivery_city,
									delivery_phone,
									delivery_email,
								};
								props.onSave(data);
								Popup.close();
							}} className="pull-right" id="zatwierdz">{intl.get('Zapisz')}</button>
						</>
					)}
				</div>
				<div className={`pakowanie_content ${isEditing ? 'edit-mode' : ''}`}>
					<div className="row">
						<div className="col-sm-12">
							<h4>{intl.get('Dane odbiorcy')}</h4>
							<div className="f_group">
								<label>{intl.get('Nazwa')}:</label>
								{isEditing ? (
									<input
										type='text'
										value={delivery_name}
										onChange={(e) => setDeliveryName(e.target.value)}
									/>
								) : (
									<div>{delivery_name}</div>
								)}
							</div>
							<div className="f_group">
								<label>{intl.get('Ulica')}:</label>
								{isEditing ? (
									<input
										type='text'
										value={delivery_street}
										onChange={(e) => setDeliveryStreet(e.target.value)}
									/>
								) : (
									<div>{delivery_street}</div>
								)}
							</div>
							<div className="f_group">
								<label>{intl.get('Kod pocztowy')}:</label>
								{isEditing ? (
									<input
										type='text'
										value={delivery_zip}
										onChange={(e) => setDeliveryZip(e.target.value)}
									/>
								) : (
									<div>{delivery_zip}</div>
								)}
							</div>
							<div className="f_group">
								<label>{intl.get('Miasto')}:</label>
								{isEditing ? (
									<input
										type='text'
										value={delivery_city}
										onChange={(e) => setDeliveryCity(e.target.value)}
									/>
								) : (
									<div>{delivery_city}</div>
								)}
							</div>
							<div className="f_group">
								<label>{intl.get('Telefon')}:</label>
								{isEditing ? (
									<input
										type='text'
										value={delivery_phone}
										onChange={(e) => setDeliveryPhone(e.target.value)}
									/>
								) : (
									<div>{delivery_phone}</div>
								)}
							</div>
							<div className="f_group">
								<label>{intl.get('Email')}:</label>
								{isEditing ? (
									<input
										type='text'
										value={delivery_email}
										onChange={(e) => setDeliveryEmail(e.target.value)}
									/>
								) : (
									<div>{delivery_email}</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</main>
		</div>
	);
};

export default ShippingDataForm;

/**
 * Registers popup plugin for shipping data.
 * @param {Object} order - Order object.
 * @param {Object} shippingData - Shipping data.
 * @param {Function} onSave - Function called on save.
 * @param {boolean} [isEditing=false] - Whether the form is in edit mode.
 */
Popup.registerPlugin('shippingData', function (order, shippingData, onSave, isEditing = false) {
	this.create({
		title: intl.get('Przesyłka'),
		className: 'shipping-data-popup',
		content: <ShippingDataForm order={order} shippingData={shippingData} onSave={onSave} isEditing={isEditing} />,
	});
});